import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["PerformancePage"] */ "/home/runner/work/mdsite4/mdsite4/components/photon/performance-page.tsx");
